/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.10",
    versionName: "0.8.0-nightly.2026.10.10",
    versionChannel: "nightly",
    buildDate: "2026-10-10T00:16:49.326Z",
    commitHash: "2edfd97d11897e6cf6301c30cd87e86d774919c1",
};
